import { render, staticRenderFns } from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=template&id=2546bc04&scoped=true&"
import script from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=style&index=0&id=2546bc04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546bc04",
  null
  
)

component.options.__file = "SubscriptionForm.Purchase.InovioPayIframe.vue"
export default component.exports